import axios from '@/utils/axios';

// Types

// API

export default {
	async getAll(research: string | null, page: number = 1, subFam: number | null, targetDate :Date | null): Promise<any> {
		if (targetDate == null){
			targetDate = new Date;
		}
		var targetDateString =targetDate.getFullYear()+"-"+(targetDate.getMonth()+1)+"-"+targetDate.getDate() ;
	//	alert(targetDateString);
		return (await axios().get(`/cashitems/?research=${research}&page=${page}&subFam=${subFam}&targetDate=${targetDateString}`)).data;
	},

};
